export const defaultLeftPosition: number = 0;
export const defaultLeftPositionWithCheckbox: number = 51;

export const pagesWithTableCheckbox = [ 'BLOGGERS' ]
